import { MatterRowContextMenu } from "@/components/features/matters/MatterRowContextMenu";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { CASE_MATTER_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import type { DashboardPinnedMatter } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState, type ReactNode } from "react";

type PinnedMatterRowContextMenuProps = {
  pinnedMatter: DashboardPinnedMatter;
  trigger: ReactNode;
};

export function PinnedMatterRowContextMenu({
  pinnedMatter,
  trigger,
}: PinnedMatterRowContextMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data: matterData } = useQuery({
    ...retrieveMatterQueryOptions(pinnedMatter.matter.id),
    enabled: isMenuOpen,
  });
  const matter = useMemo(() => {
    const detailedMatter = matterData?.data;

    return {
      attorneyFee: detailedMatter?.attorneyFee ?? null,
      dateModified: detailedMatter?.dateModified ?? pinnedMatter.dateModified,
      emailAddress: detailedMatter?.emailAddress ?? null,
      id: pinnedMatter.matter.id,
      status: detailedMatter?.status
        ? {
            id: detailedMatter.status.id,
            label: detailedMatter.status.label,
          }
        : pinnedMatter.matter.status,
      statusId: detailedMatter?.statusId ?? pinnedMatter.matter.status.id,
      title: detailedMatter?.title ?? pinnedMatter.matter.title,
    };
  }, [matterData?.data, pinnedMatter]);

  return (
    <MatterRowContextMenu
      allowedStatusCategories={CASE_MATTER_STATUS_CATEGORY_OPTIONS}
      matter={matter}
      trigger={trigger}
      onOpenChange={setIsMenuOpen}
    />
  );
}
